import { SnackbarProvider } from 'notistack'
import React from 'react'

import HubloSnackbar from './HubloSnackbar'

interface AppSnackbarProviderProps {
  children: React.ReactNode
}

export const AppSnackbarProvider = ({ children }: AppSnackbarProviderProps) => {
  const notistackRef = React.createRef<SnackbarProvider>()

  return (
    <SnackbarProvider
      Components={{
        default: HubloSnackbar,
        error: HubloSnackbar,
        info: HubloSnackbar,
        success: HubloSnackbar,
        warning: HubloSnackbar,
      }}
      ref={notistackRef}
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={3000}
      transitionDuration={{ enter: 300, exit: 300 }}
    >
      {children}
    </SnackbarProvider>
  )
}
